import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { AssessmentList } from 'Components/assessments/AssessmentList'
import { useAuthTenant } from 'store/auth'
import { Main as Container } from 'Components/Main'
import { PageHeader, Button } from 'Components/ui'

export const AssessmentsPage = () => {
  const { t } = useTranslation(['gap-analysis'])
  const navigate = useNavigate()
  const selectedTenant = useSelector(useAuthTenant)

  return (
    <Container>
      <PageHeader
        title={t('gap-analysis:assessment.page.title')}
        segments={[
          { label: t('common:breadcrumbs.thirdPartyRiskManagement') },
          { label: t('gap-analysis:assessment.page.title') },
        ]}
        actions={
          <Button
            variant="primary"
            onClick={() => navigate('/vendor-assessments/new')}
            startIcon={
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
              </svg>
            }
            sx={{ height: '40px', padding: '0 18px' }}
          >
            {t('gap-analysis:assessment.page.generateButton')}
          </Button>
        }
      />

      <AssessmentList tenant={selectedTenant?.slug} />
    </Container>
  )
}
